import React, { useEffect, useState } from 'react';
import client from './contentfulClient';
import { Link } from 'react-router-dom';

const Creative = () => {
  const [allProjects, setAllProjects] = useState([]); // all fetched projects
  const [visibleCount, setVisibleCount] = useState(3); // how many projects are currently visible

  useEffect(() => {
    client
      .getEntries({ content_type: 'creative' }) // replace with your confirmed content type ID if different
      .then((res) => {
        setAllProjects(res.items);
      })
      .catch(console.error);
  }, []);

  const handleLoadMore = () => {
    setVisibleCount((prevCount) => prevCount + 3);
  };

  const visibleProjects = allProjects.slice(0, visibleCount);
  const hasMore = visibleCount < allProjects.length;

  return (
    <section className="creative_wrapper">
      <div className="container">
        <h2 className="mb-4"><b>Creative</b></h2>
        <div className="row">
          {visibleProjects.map((item) => {
            const { projectName, description, thumbnail } = item.fields;
            const imageUrl = thumbnail?.fields?.file?.url;

            return (
              <div className="col-md-4" key={item.sys.id}>
                <Link to={`/project/${item.sys.id}`}>
                  <div className="creative-post">
                  <img
  src={
    imageUrl
      ? `https:${imageUrl}?w=500&q=75&fm=webp`
      : 'assets/img/dizajn.png'
  }
  alt={projectName}
  loading="lazy"
/>
                    <div className="overlay">
                      <div className="text">
                        <h3>{projectName}</h3>
                        
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
        {hasMore && (
          <div className="d-flex justify-content-end mt-4">
            <a href="#" onClick={(e) => { e.preventDefault(); handleLoadMore(); }}>Load More</a>
          </div>
        )}
      </div>
    </section>
  );
};

export default Creative;
